<template>
    <div v-if="iconUrl">
        <div
            class="content-icon"
            :class="{ 'circle': circle }"
            :style="{ height: height }"
        >
            <img
                :src="iconUrl"
                alt="image"
            >
        </div>
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps<{
    icon?: string | null
    iconUrl?: string | null
    circle?: boolean
    size?: number | string
}>()

const height = computed(() => {
    if (typeof props.size === 'number') {
        return `${props.size}px`
    }

    return props.size
})
</script>

<style lang="scss" scoped>
.content-icon {
    padding: 20px;
    &-wrapper  {
        height: 100px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    img {
        height: 100%;
        margin: 0 auto;
    }
}
</style>
